import { useReactiveVar } from '@bestseller/retail-planning.utils.reactive-vars';
import { comparableStoreTypeVar } from 'src/infrastructure/local_state';

export const useComparableStore = () => {
    const [comparableStore] = useReactiveVar(comparableStoreTypeVar);
    return comparableStore;
};
